import React from 'react';
import { Navbar } from 'react-bootstrap';

const Header = () => {
    return (
        <Navbar bg="light" className="navbar-header">
            <Navbar.Brand href="#" style={{ display: "flex" }}>
                <img
                    alt=""
                    src="./images/INV_Logo.png"
                    width="294"
                    height="40"
                    className="d-inline-block"
                />
            </Navbar.Brand>
        </Navbar>
    );
};

export default Header;
